import React, { useState, useRef, useCallback } from 'react';
import { IoClose, IoCheckmark, IoRemove, IoAdd } from 'react-icons/io5';
import './AvatarCrop.css';

export default function AvatarCrop({ imageUrl, onConfirm, onCancel }) {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    setDragging(true);
    setDragStart({ x: clientX - position.x, y: clientY - position.y });
  }, [position]);

  const handleMouseMove = useCallback((e) => {
    if (!dragging) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    setPosition({ x: clientX - dragStart.x, y: clientY - dragStart.y });
  }, [dragging, dragStart]);

  const handleMouseUp = useCallback(() => {
    setDragging(false);
  }, []);

  const handleConfirm = () => {
    const canvas = document.createElement('canvas');
    const size = 300;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const img = imgRef.current;
    if (!img) return;

    const containerSize = 280;
    const imgScale = (containerSize * scale) / Math.min(img.naturalWidth, img.naturalHeight);
    const drawWidth = img.naturalWidth * imgScale;
    const drawHeight = img.naturalHeight * imgScale;

    const offsetX = (containerSize / 2 + position.x - drawWidth / 2) * (size / containerSize);
    const offsetY = (containerSize / 2 + position.y - drawHeight / 2) * (size / containerSize);

    ctx.drawImage(img, offsetX, offsetY, drawWidth * (size / containerSize), drawHeight * (size / containerSize));

    canvas.toBlob((blob) => {
      if (blob) onConfirm(blob);
    }, 'image/jpeg', 0.8);
  };

  return (
    <div className="avatar-crop-overlay">
      <div className="avatar-crop-modal">
        <div className="avatar-crop-header">
          <h3>Recadrer ta photo</h3>
          <button className="avatar-crop-close" onClick={onCancel}><IoClose /></button>
        </div>

        <div
          className="avatar-crop-area"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleMouseDown}
          onTouchMove={handleMouseMove}
          onTouchEnd={handleMouseUp}
        >
          <div className="avatar-crop-circle" />
          <img
            ref={imgRef}
            src={imageUrl}
            alt="Crop"
            className="avatar-crop-img"
            style={{
              transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
            }}
            draggable={false}
          />
        </div>

        <div className="avatar-crop-zoom">
          <button onClick={() => setScale(s => Math.max(0.5, s - 0.1))}><IoRemove /></button>
          <input
            type="range"
            min="0.5"
            max="3"
            step="0.05"
            value={scale}
            onChange={(e) => setScale(parseFloat(e.target.value))}
          />
          <button onClick={() => setScale(s => Math.min(3, s + 0.1))}><IoAdd /></button>
        </div>

        <div className="avatar-crop-actions">
          <button className="btn btn-ghost" onClick={onCancel}><IoClose /> Annuler</button>
          <button className="btn btn-primary" onClick={handleConfirm}><IoCheckmark /> Confirmer</button>
        </div>
      </div>
    </div>
  );
}